<template>
  <v-snackbar v-if="snackbarText"
              centered
              top
              v-model="snackbarStatus"
              :color="snackbarColor"
              rounded="xl"
  >
    <p v-html="snackbarText" class="pa-0 ma-0 white--text"></p>
    <template v-slot:action="{ attrs }">
      <v-btn
          fab
          text
          x-small
          v-bind="attrs"
          @click="$store.dispatch('closeSnackbar')"
      >
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackBar",

  data() {
    return {
      snackbarStatus: false,
      snackbarColor: '#67B930',
      snackbarText: null,
    }
  },

  watch: {
    '$store.state.snackbarStatus': function (val) {
      this.snackbarStatus = val
    },
    '$store.state.snackbarColor': function (val) {
      this.snackbarColor = val
    },
    '$store.state.snackbarText': function (val) {
      this.snackbarText = val
    },

    snackbarStatus: function (val) {
      if (val !== this.$store.state.snackbarStatus) {
        this.$store.dispatch("closeSnackbar")
      }
    },
  }
}
</script>

<style scoped>
</style>
